import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PatchOps from '@leverege/api-patch-ops'
import { TemplateFactory } from '~/editors/template'
import { TemplateActions, BreadcrumbActions } from '~/actions';

import S from './TemplatesScreen.css';

class TemplateInfoScreen extends React.Component {

  componentDidMount() {
    this.props.dispatch( TemplateActions.get( this.props.match.params.projectId, this.props.match.params.templateId ) );
  }

  componentWillReceiveProps( next ) {
    const { templates } = next
    const { params } = this.props.match
    const templateId = params.templateId
    const template = templates.lookup[templateId]
    if ( template ) {
      this.props.dispatch( BreadcrumbActions.setBreadcrumbs( 
        [ { name : 'Templates', link : `/project/${template.projectId}/template` }, 
          { name : template.name } ] ) )
    }
  
  }
  
  onTemplateChange = ( { target, path, value } ) => {
    const { params } = this.props.match
    const patchOps = PatchOps().replace( path, value ).ops()
    this.props.dispatch( TemplateActions.update( params.projectId, target, patchOps ) )
  }

  render() {
    const { templates } = this.props
    const { params } = this.props.match
    const templateId = params.templateId
    const template = templates.lookup[templateId]
    if ( template == null ) {
      return null
    }

    const details = TemplateFactory.createInfoEditor( 
      template, {
        onChange : this.onTemplateChange
      } )
    return <div className={S.pad}>{details}</div>
  }
}

export default connect(
  state => ( {
    templates : state.templates
  } )
)( TemplateInfoScreen );
